import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscriber, Subscription } from 'rxjs';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNPatient } from 'src/app/models/cnpatient';
import { SNAgendaDay } from 'src/app/models/snagendaday';
import { SNSMSMessage } from 'src/app/models/snsmsmessage';
import { ODBService } from 'src/app/services/odb.service';
import { PatientService } from 'src/app/services/patient.service';
import { SmsService } from 'src/app/services/sms.service';
import { UserConfigService } from 'src/app/services/user-config.service';

@ManageType('SmsConversationDialogComponent')
@Component({
  selector: 'app-sms-conversation-dialog',
  templateUrl: './sms-conversation-dialog.component.html',
  styleUrls: ['./sms-conversation-dialog.component.scss']
})
export class SmsConversationDialogComponent implements OnInit, OnDestroy {

  public patient: CNPatient;
  public agenda: SNAgendaDay;
  public message = '';
  public messages: SNSMSMessage[] = [];

  private messagesSub: Subscription;

  constructor(private dialogRef: MatDialogRef<SmsConversationDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              private sms: SmsService, private userConfig: UserConfigService, private odb: ODBService) {
    if (typeof data.message !== 'undefined') {
      this.message = data.message;
    }
    if (typeof data.patient !== 'undefined') {
      this.patient = data.patient;
      // Load patient sms messages
      this.loadMessages();
    }
    if (typeof data.patientid !== 'undefined') {
      // load patient
      this.odb.itemById(data.patientid).subscribe(item => {
        this.patient = item as CNPatient;
        // Load patient sms messages
        this.loadMessages();
      });
    }
    if (typeof data.agendaid !== 'undefined') {
      this.odb.itemById(data.agendaid, ['SNItem.SNAgendaAppointment'], true).subscribe(item => {
        this.agenda = (item as SNAgendaDay);
      });
    }
  }
  ngOnDestroy(): void {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }
  }

  ngOnInit(): void {
  }

  loadMessages(): void {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }
    if (this.patient) {
      this.messagesSub = this.sms.patientSms(this.patient).subscribe(messages => {
        this.messages = messages;
      });
    }
  }

  send(): void {
    if (this.patient) {
      const sendSub = this.sms.sendSmsPatient(this.patient, this.message, this.userConfig.user.id.toString()).subscribe(message => {
        sendSub.unsubscribe();
        this.loadMessages();
      }, error => {
        this.loadMessages();
      });
    }
    if (this.agenda) {
      const sendSub = this.sms.sendSmsAgenda(this.agenda, this.message, this.userConfig.user.id.toString()).subscribe(message => {
        sendSub.unsubscribe();
        this.dialogRef.close();
      }, error => {
        this.dialogRef.close();
      });
    }
  }
}
